import { cva } from "class-variance-authority"

export const cardVariants = cva("", {
  variants: {
    variant: {
      default: "",
      bordered: "border-2",
      filled: "bg-neutral-950 text-white",
      gradient: "bg-gradient-to-br from-neutral-900 to-neutral-800 text-white"
    },
    size: {
      default: "p-6",
      large: "p-12"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}) 